/* ============================================================
   Líder — adicionar ao carrinho via AJAX (sem reload)
   Qualquer botão com [data-lider-add] e data-variant-id adiciona
   o item via /cart/add.js, atualiza a bolha e abre o drawer.
   ============================================================ */
(function () {
  'use strict';

  function refreshBubble() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (c) {
        document.querySelectorAll('[data-lider-cart-count]').forEach(function (b) {
          b.textContent = c.item_count < 100 ? c.item_count : '99';
          b.hidden = c.item_count === 0;
        });
      })
      .catch(function () {});
  }

  function bindAddButtons() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-lider-add]');
      if (!btn) return;
      e.preventDefault();

      var variantId = btn.dataset.variantId;
      if (!variantId || btn.disabled) return;

      var originalHtml = btn.innerHTML;
      var qty = parseInt(btn.dataset.quantity, 10) || 1;
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          btn.innerHTML = 'Adicionado ✓';
          refreshBubble();
          if (window.LiderCart && typeof window.LiderCart.openRefreshed === 'function') {
            window.LiderCart.openRefreshed();
          }
          setTimeout(function () {
            btn.innerHTML = originalHtml;
            btn.disabled = false;
          }, 2200);
        })
        .catch(function () {
          btn.innerHTML = originalHtml;
          btn.disabled = false;
        });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAddButtons);
  } else {
    bindAddButtons();
  }
})();
